
























































import _ from 'lodash'
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import InputGeneric from '@/components/InputGeneric.vue'
import {
  postBulkCompanyRepresentativeReport,
} from '@/utils/ApiServices'
import { handle } from '@/utils/ErrorHandling'
import { AxiosResponse } from 'axios'

@Component({
  components: {
    InputGeneric,
  }
})
export default class DanhGiaNDDTaoBaoCao extends Vue {
  @Prop(Number) readonly year!: number
  @Prop(Array) readonly reportTypes!: Array<string>

  loading = false

  // ======================================================================

  get privateYear () {
    return this.year
  }
  set privateYear (year: number) {
    this.updateYear(year)
  }

  get yearChoices () {
    const currentYear = (new Date).getFullYear()
    const choices = []
    for (let year = currentYear; year >= 1996; year --) {
      choices.push({ text: year.toString(), value: year })
    }
    return choices
  }

  // ======================================================================

  reportTypeChoices = ['PLDGNDD']

  get privateReportTypes () {
    return this.reportTypes
  }
  set privateReportTypes (reports: Array<string>) {
    this.updateReportTypes(reports)
  }

  get selectAllReportTypes () {
    return _.isEqual(this.reportTypes.sort(), this.reportTypeChoices.sort())
  }
  set selectAllReportTypes (val) {
    if (val) {
      this.updateReportTypes(this.reportTypeChoices)
    } else {
      this.updateReportTypes([])
    }
  }

  // ======================================================================

  @Emit('update-year')
  updateYear (year: number) { return year }

  @Emit('update-report-types')
  updateReportTypes (reports: Array<string>) { return reports }

  @Emit('update-report-data')
  updateReportData () { return }

  // ======================================================================

  createReportData () {
    if (this.loading) return
    this.loading = true

    const mapper: { [index: string]: Function } = {
      'PLDGNDD': postBulkCompanyRepresentativeReport,
    }

    const promises: Array<Promise<AxiosResponse>> = []
    this.reportTypes.forEach(type => {
      const service = mapper[type]
      promises.push(service(this.year))
    })

    Promise.all(promises)
      .then(() => {
        this.updateReportData()
      })
      .catch(error => {
        handle(error)
      })
      .finally(() => {
        this.loading = false
      })
  }
}
